import { type CarrierDef } from '../common.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  accountNumber,
  'subscription-key',
] as const

export type llsfCredType = (typeof credentialTypes)[number]
export const llsf: CarrierDef<llsfCredType> = {
  name: 'Almex',
  scac: 'llsf',
  credentialTypes,
  engineLayers: ['pickup'],
  legacyCredMap: [
    ...userPassMap,
    ['account-number', 'accountNumber'],
    ['subscription-key', 'apiKey'],
  ],
}
